import React, { PureComponent, ReactNode } from "react";
import Helmet from "react-helmet";

import { translate } from "../../../../../services/translation.service";

interface IProps {
  isOrderConfirmationPage: boolean;
}

export default class Notify extends PureComponent<IProps> {
  public render(): ReactNode {
    const { isOrderConfirmationPage } = this.props;

    if (isOrderConfirmationPage) {
      return (
        <img
          src={
            "https://adtrack.adleadevent.com/adtcker.php?st=25cbde3e-7825-49d8-9dcb-8eced5487dca&c=1"
          }
          style={{
            border: 0,
            height: 1,
            width: 1,
          }}
          alt={translate("global.offer10")}
        />
      );
    }

    return (
      <Helmet>
        <script
          type="text/javascript"
          src="https://d2lf0na4rc04lu.cloudfront.net/25cbde3e-7825-49d8-9dcb-8eced5487dca/notifyme.js"
          id="_notifyScriptId"
          async={true}
        />
      </Helmet>
    );
  }
}
